import { render } from "./LineUps.vue?vue&type=template&id=38744c19&scoped=true"
import script from "./LineUps.vue?vue&type=script&lang=js"
export * from "./LineUps.vue?vue&type=script&lang=js"

import "./LineUps.vue?vue&type=style&index=0&id=38744c19&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38744c19"]])

export default __exports__